/**
 * All HTML content generated by WordPress needs to be scrubbed to
 * make sure links and srouces are targeting the frontend, not the WP server.
 *
 * @param {String} content HTML content string from WordPress
 */

// See: https://gitlab.com/FathomCompany/ringdna-brandsite/issues/12
export const parseHTML = content => {
    if (!content) return "";

    // Set all relative image sources to use the WordPress domain
    content = content.replace(/src="\//g, `src="${process.env.SITE_URL}/`);

    // Set all links from the WordPress domain to use the Frontend domain
    const linkRegex = new RegExp(`href="${process.env.WORDPRESS_URL}`, "g");
    content = content.replace(linkRegex, `href="`);

    // Strip unrendered shortcodes from content
    content = content.replace(/\[\/?.*?\]/g, "");

    return content;
};
